import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'ui-no-data-message',
    templateUrl: './no-data-message.component.html',
    styleUrls: ['./no-data-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NoDataMessageComponent {}
